export default {
  "container": "RcDWP",
  "webview": "ilOnp",
  "avatar_list": "UfNvF",
  "avatar": "qj5O-",
  "user_avatar": "Aqedb",
  "modal": "_0yDUP",
  "voted_users_modal": "qsyl5",
  "overlay": "F9WjD",
  "user_card": "CSC4s",
  "user_name": "iaHcF",
  "voted_users_modal_header": "h3Wdc",
  "cta": "huUQI",
  "close_icon": "m2uVu",
  "title": "iZSH5",
  "member_list_container": "KYij0",
  "member_list": "vBc1t",
  "loader": "XccEL",
  "anonymous_counter": "Bf8WL",
  "spinner": "DuxFU",
  "spin": "U4oNw"
};